<template>
  <Component
    :is="iconOnly ? Tooltip : 'span'"
    :title="
      iconOnly ? $t(`components.tooltips.priorities.${props.priority}`) : ''
    "
    side="bottom"
    class="!w-fit"
    disableHoverableContent
    ignoreNonKeyboardFocus
  >
    <Badge
      :label="text"
      :type="badgeType"
      :color="color"
      :size="size"
      :ariaHidden="iconOnly"
      :icon="iconOnly ? 'only' : hideIcon ? false : 'leading'"
      :class="
        variant === 'dark'
          ? {
              '!text-white !bg-utility-gray-400 ': priority === 'low',
              '!bg-utility-warning-400': priority === 'normal',
              '!bg-utility-error-500': priority === 'high',
            }
          : {}
      "
    >
      <Icon name="error-circle" :size="size" />
    </Badge>
  </Component>
</template>

<script setup>
import { Tooltip } from "@/SharedComponents/Tooltips";
import { Badge } from "@/SharedComponents/Badges";
import { Icon } from "@/SharedComponents/Icon";
import { priorities, sizes, variants } from "./priority";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  priority: {
    type: String,
    validator: (val) => priorities.includes(val),
    required: true,
  },
  iconOnly: {
    type: Boolean,
    required: false,
  },
  variant: {
    type: String,
    validator: (val) => variants.includes(val),
    default: "light",
  },
  size: {
    type: String,
    validator: (val) => sizes.includes(val),
    default: "sm",
  },
  // optional label to override the default priority label
  label: {
    type: String,
    required: false,
  },
  hideIcon: {
    type: Boolean,
    required: false,
  },
});

const color = computed(() => {
  switch (props.priority) {
    case "low":
      return "gray";
    case "normal":
      return "warning";
    case "high":
      return "error";
    default:
      return "gray";
  }
});

const badgeType = computed(() => {
  switch (props.variant) {
    case "light":
      return "light";
    case "dark":
      return "full";
    default:
      return "light";
  }
});

const text = computed(() => {
  if (!props.icon) {
    return props.label || t(`components.priority.${props.priority}`);
  } else return "";
});
</script>
